import React, { useState, useEffect } from "react";

const HotspotEditor = ({ imageUrl, hotspots, onChange }) => {
  const [localHotspots, setLocalHotspots] = useState(hotspots || []);

  useEffect(() => {
    setLocalHotspots(hotspots);
  }, [hotspots]);

  const handleImageClick = (e) => {
    const rect = e.target.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;

    const newHotspot = {
      hotspotNumber: localHotspots.length + 1,
      label: `Hotspot ${localHotspots.length + 1}`,
      content: "Edit content",
      shape: "circle",
      coordinates: JSON.stringify({ x, y }),
    };

    const updated = [...localHotspots, newHotspot];
    setLocalHotspots(updated);
    onChange(updated);
  };

  const updateHotspot = (index, field, value) => {
    const updated = localHotspots.map((h, i) =>
      i === index ? { ...h, [field]: value } : h
    );
    setLocalHotspots(updated);
    onChange(updated);
  };

  return (
    <div className="relative inline-block border rounded-md overflow-hidden">
      <img
        src={imageUrl}
        alt="Hotspot"
        className="max-w-full h-auto cursor-crosshair"
        onClick={handleImageClick}
      />

      {localHotspots.map((h, i) => {
        let coords = {};
        try {
          coords = JSON.parse(h.coordinates || "{}");
        } catch {
          coords = {};
        }

        const { x = 0, y = 0 } = coords;

        return (
          <div
            key={i}
            className="absolute bg-red-500 text-white text-xs rounded-full w-6 h-6 flex items-center justify-center cursor-pointer"
            style={{
              top: `${y}%`,
              left: `${x}%`,
              transform: "translate(-50%, -50%)",
            }}
            title={h.label}
          >
            {i + 1}
          </div>
        );
      })}

      <div className="mt-4 bg-gray-50 p-4 rounded-md shadow-sm">
        {localHotspots.map((h, i) => (
          <div key={i} className="flex gap-2 mb-2">
            <input
              className="border p-1 rounded w-1/4"
              value={h.label}
              onChange={(e) => updateHotspot(i, "label", e.target.value)}
              placeholder="Label"
            />
            <input
              className="border p-1 rounded w-1/2"
              value={h.content}
              onChange={(e) => updateHotspot(i, "content", e.target.value)}
              placeholder="Content"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default HotspotEditor;
